/**
 * Uploads ALL files from ALL media queries to firebase storage, and upon success removes the TrackedMedia element from indexedDB
 * @updated 28/03/2024 - 15:16:24
 * @param ctx NotificationStateModel
 * @see libs/app/client/shared/components/notifications/data-access/src/lib/states/notifications.state.ts
 */
export class Upload {
  public static readonly type = '[Notifications] Upload';
}
